import { MultipleContactWarning } from 'legacy/lut/components/common/multipleContactWarning/MultipleContactWarning'

import { ClickablePhoneWrapper } from 'clickNgo/components/clickablePhoneWrapper'
import { IContact } from 'clickNgo/entities/contact'
import { CustomTableColumn } from 'shared/components/customTableHeaderCell/models'

import { partnerContactsTranslation } from './translation'

import styles from './PartnerContacts.module.scss'

export enum ContactTypeSelectorSegment {
  SelectedPartner = 0,
  AllContacts = 1,
  MyRequest = 2,
  NewContacts = 3,
  Inactive = 4,
  ProfilingRequests = 5,
}

export const contactTableColumns: Array<CustomTableColumn<IContact>> = [
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.contactId,
    columnField: 'contactId',
    styles: { width: '160px' },
    bodyCellRender: (data, field) => {
      return (
        <div className={styles.contactIdCell}>
          <MultipleContactWarning email={data.email} />
          {`${data[field] || '-'}`}
        </div>
      )
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.learnerId,
    columnField: 'learnerId',
    styles: { width: '140px' },
    bodyCellRender: (data, field) => {
      return `${data[field] || '-'}`
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.status,
    columnField: 'status',
    styles: { width: '140px' },
    bodyCellRender: (data, field) => {
      return `${data[field] || '-'}`
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.firstName,
    columnField: 'firstName',
    styles: { width: '140px' },
    bodyCellRender: (data, field) => {
      return `${data[field] || '-'}`
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.lastName,
    columnField: 'lastName',
    styles: { width: '140px' },
    bodyCellRender: (data, field) => {
      return `${data[field] || '-'}`
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.hpRoles,
    columnField: 'hpRoles',
    styles: { width: '140px', whiteSpace: 'normal' },
    bodyCellRender: (data, field) => {
      return `${data[field] || '-'}`
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.email,
    columnField: 'email',
    styles: { width: '140px' },
    bodyCellRender: (data, field) => {
      return `${data[field] || '-'}`
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.mobilePhoneNumber,
    columnField: 'mobilePhoneNumber',
    styles: { width: '140px', maxWidth: '200px' },
    bodyCellRender: (data) => {
      const { mobilePhoneCode = '', mobilePhoneNumber = '', hpdContactGUID, partnerId } = data
      const phoneValue = `${mobilePhoneCode}${mobilePhoneNumber}` || '-'

      if (mobilePhoneNumber) {
        return (
          <ClickablePhoneWrapper
            guid={hpdContactGUID}
            partnerId={partnerId}
            phoneNumber={phoneValue}
          />
        )
      }

      return <div>{phoneValue}</div>
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.workPhoneNumber,
    columnField: 'workPhoneNumber',
    styles: { width: '140px', maxWidth: '200px' },
    bodyCellRender: (data) => {
      const { workPhoneNumber = '', workPhoneCode = '', hpdContactGUID, partnerId } = data
      const phoneValue = `${workPhoneCode}${workPhoneNumber}` || '-'
      if (workPhoneNumber) {
        return (
          <ClickablePhoneWrapper
            guid={hpdContactGUID}
            partnerId={partnerId}
            phoneNumber={phoneValue}
          />
        )
      }

      return <div>{phoneValue}</div>
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.userStatus,
    columnField: 'userStatus',
    styles: { width: '160px' },
    bodyCellRender: (data, field) => {
      switch (data[field]) {
        case 'Contact':
          return 'Contact'
        case 'G_UPP_Partner_User':
          return 'User'
        case 'G_UPP_Partner_Admin_User':
          return 'Admin User'
        default:
          return '-'
      }
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.partnerId,
    columnField: 'partnerId',
    styles: { width: '160px' },
    bodyCellRender: (data, field) => {
      return `${data[field] || '-'}`
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.communicationName,
    columnField: 'communicationName',
    styles: { width: '180px' },
    bodyCellRender: (data, field) => {
      return `${data[field] || '-'}`
    },
  },
  {
    columnTitle: partnerContactsTranslation.contacts.table.columns.city,
    columnField: 'city',
    styles: { width: '140px' },
    bodyCellRender: (data, field) => {
      return `${data[field] || '-'}`
    },
  },
]
